import { getJwtToken } from '@/utils/authManager';

import intersect from '@/utils/arrayIntersec';

export default {
  data: () => ({
    permissions: {
      create: true,
      edit: true,
      replace: true,
      delete: true,
    },
    userGroups: [],
  }),
  created() {
    // fetch user groups
    this.fetchUserGroups();
  },
  computed: {
    hasEditTogglePermissions() {
      return intersect(this.userGroups, ['admin', 'localadmin', 'user']);
    },
    hasCreatePermissions() {
      return this.permissions.create && this.editMode
        && intersect(this.userGroups, ['admin', 'localadmin', 'user']);
    },
    hasTagCreatePermissions() {
      return this.permissions.create && this.editMode
        && intersect(this.userGroups, ['admin', 'localadmin']);
    },
    hasEditPermissions() {
      return this.permissions.edit && this.editMode
        && intersect(this.userGroups, ['admin', 'localadmin', 'user']);
    },
    hasTagEditPermissions() {
      return this.permissions.edit && this.editMode
        && intersect(this.userGroups, ['admin', 'localadmin']);
    },
    hasReplacePermissions() {
      return this.permissions.replace && this.editMode
        && intersect(this.userGroups, ['admin', 'localadmin', 'user']);
    },
    hasDeletePermissions() {
      return this.permissions.delete && this.editMode
        && intersect(this.userGroups, ['admin', 'localadmin']);
    },
    hasTagDeletePermissions() {
      return this.permissions.delete && this.editMode
        && intersect(this.userGroups, ['admin']);
    },
  },
  methods: {
    fetchUserGroups() {
      this.userGroups = getJwtToken().payload['cognito:groups']
        .map(group => group.toLowerCase());
    },
  },
};
